export const isVerboseLoggingEnabled = (): boolean => {
  if (typeof window === "undefined") {
    return false;
  }
  const flag = (window as any).__CABINET_DEBUG_VERBOSE;
  if (typeof flag === "function") {
    try {
      return Boolean(flag());
    } catch (_error) {
      return true;
    }
  }
  return Boolean(flag);
};

